<template>
  <div id="nav">
    <b-navbar toggleable="md" type="dark" variant="dark">
      <!-- <b-container> -->
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-navbar-brand :to="{ name: 'Home' }">Home</b-navbar-brand>

      <b-collapse is-nav id="nav-collapse">
        <b-navbar-nav>
          <b-nav-item-dropdown text="Facturació">
            <b-dropdown-item :to="{ name: 'Factures' }">Factures</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item :to="{ name: 'ProximasFacturas' }">Previsió Facturació</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'FacturaLauncher' }">Facturar</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item-dropdown text="Maestros">
            <b-dropdown-item :to="{ name: 'Clients' }">Clients</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'Grups' }">Grups</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'Centres' }">Centres</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item :to="{ name: 'Productes' }">Productes</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'CPs' }">Productes-Clients</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item-dropdown text="Configuració">
            <b-dropdown-item :to="{ name: 'Series' }">Series Factura</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'Bancs' }">Bancs</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'Verifactu' }">Verifactu</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <b-navbar-nav>
          <b-nav-item-dropdown text="Informes">
            <b-dropdown-item :to="{ name: 'InformeVenciments' }">Venciments</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'InformePP' }">Pendent Pagament</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'InformeLicencias' }">Llicencies Actives</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-navbar-brand v-if="!loggedIn" right :to="{ name: 'Login' }">Login</b-navbar-brand>
          <b-nav-item-dropdown v-else right>
            <template v-slot:button-content>
              <em>{{ loggedUserName }}</em>
            </template>
            <!-- Using 'button-content' slot -->
            <b-dropdown-item :to="{ name: 'UserProfile' }">Mi Perfil</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'Users', params: { id: null } }">Usuarios</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'Register' }">Registrar usuario</b-dropdown-item>
            <!-- <b-avatar :to="{ name: 'About'}" variant="primary" class="mr-3">CL</b-avatar>Perfil -->
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="#" @click="logout">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>

      <!-- </b-container> -->
    </b-navbar>
  </div>
</template>

<script>
  import { authComputed } from "@/store/helpers.js";

  export default {
    name: "Home",
    computed: {
      ...authComputed,
    },
    methods: {
      logout() {
        this.$store.dispatch("logout");
      },
    },
  };
</script>
